module.exports = "/_next/static/images/be5850c4ec1a115f8f4b4772c15b5a47-shield.svg.webp";